import React, { useEffect, useState } from "react";
import { useSearch } from "../../../Contexts/SearchContext";
import {
  getActiveFilters,
  getActiveFiltersWithBefore,
  setFilterState,
  dispatchActiveFilters,
  updateDropdownHeadingLabels,
  resetFilters,
} from "../../../../helpers";
import '../FilterDrawerAccordion/FilterDrawerAccordion.scss'
import Filter from '../Filter/Filter'

const FilterDrawerCategoryAccordion = ({
  filterJson,
  label,
  subMenuClass,
  index,
  labels,
}) => {
  const { state, dispatch } = useSearch();

  const { filteredResults, selectedFilters, componentElement, completeSearchResultSet } = state;

  useEffect(() => {
    updateDropdownHeadingLabels(componentElement);

  }, [selectedFilters]);

  const [isActive, setIsActive] = useState(true);//for automatic accordion open
  const [selectedFiltersHeadingsLocal, setSelectedFiltersHeadingsLocal] =
    useState([]);

  let isActiveClass = isActive ? " active" : "";

  const trackFilterCheckForDataLayer = (checkbox) => {
    let filterTitle = checkbox.nextSibling?.textContent;
    let filterCategory = checkbox
      ?.closest(".cmp-accordion__item, .cmp-accordion__sub-item")
      ?.querySelector(".cmp-accordion__title")?.textContent;

    window.adobeDataLayer?.push({
      event: window.adobeDataLayerEvents?.component.searchFilterApplied,
      linkDetails: {
        clickName: 'Search Refinement Actions',
        clickType: `Filter Checkbox ${filterCategory}`,
        clickLocation: 'Product Finder Filter Rail',
        filter: {
          category: `filter by ${filterCategory}`,
          values: filterTitle
        }
      }
    });
  };
  const updateFilters = (event) => {
    let filterData = [];
    let checkbox = event.target;
    let parent = checkbox.closest(".cmp-accordion__content-item");
    let resultSection = document.querySelector(`.cmp-product-finder__main-section`);//added

    if (checkbox.checked) {
      trackFilterCheckForDataLayer(checkbox);
    } else {
      // Extract all elements with data-filter-id inside resultSection
      let filterElements = resultSection ? resultSection.querySelectorAll("[data-filter-id]") : [];

      filterElements.forEach((el) => {
        filterData.push({
          element: el,
          filterId: el.getAttribute("data-filter-id")
        });
      });

      validateFilterSelection(checkbox.value, filterData);
    }

    let localCheckedFilters = getActiveFilters(parent, dispatch);
    setSelectedFiltersHeadingsLocal(localCheckedFilters);
    
    setFilterState(checkbox.value, componentElement, checkbox.checked);
 
    // Reset the filter if tier-2 has no active filters
    if (!localCheckedFilters.length) {
      dispatch(dispatchActiveFilters(completeSearchResultSet));
    } else {
      dispatch({
        type: "UPDATE_SELECTED_FILTERS",
        payload: getActiveFilters(componentElement),
      });
    }
  }; 
  

  //To validate and remove the unchecked categories from results section
  const validateFilterSelection = (selectedValue, filterData) => {
    if (!selectedValue) {
       return false;
    }

    if (filterData.length === 0) {
       return false;
    }

    let isValid = false;

    filterData.forEach(({ element, filterId }) => {
      if (filterId === selectedValue) {

        let closeButton = element.querySelector(".close");
        if (closeButton) {
          closeButton.click();
        }

        isValid = true;
      }
    });

    if (!isValid) {
      console.error(`Filter value '${selectedValue}' was not found in any element.`);
    }

    return isValid;
  };
  
  const getLocalFilterHeadings = () => {
    return selectedFiltersHeadingsLocal
      .map((filter) => {
        return filter.label;
      })
      .join(", ");
  };

  //Open's accoridon dynamically
  useEffect(() => {
    const activeFilters = getActiveFiltersWithBefore();
    if (activeFilters.length > 0) {
      setIsActive(activeFilters.length > 0);
    } else if (getActiveFilters(componentElement).length > 0) {
      setIsActive(true);
    }
  }, [filteredResults]); 
 
  if (filterJson) {
    return (
      <div
        className={`cmp-accordion__${subMenuClass}item${
          isActive ? " open" : ""
        }`}
      >
        <button
          aria-expanded={isActive ? "true" : "false"}
          aria-controls={"accordion-item-" + index}
          className="cmp-accordion__title-button cmp-accordion-title-heading"
          onClick={() => setIsActive(!isActive)}
        >
          <div className="cmp-accordion__dropdown-heading">
            <div className="cmp-accordion__title">{label}</div>
            <div className="cmp-accordion__selected-filters-heading hide-title">
              {getLocalFilterHeadings()}
            </div>
            <span className={`chevron${isActiveClass}`}></span>
          </div>
        </button>
        <div className="cmp-accordion__content" id={"accordion-item-" + index}>
          <ul>
          <li className="cmp-accordion__content-item">
          {filterJson.productsAndServices?.dropdowns?.map((data, index) => {
                  return data.filters.map((filter) => {
                    if (filter && filter.label.trim() !== "") {
                        
                      //check if the labels are empty or data.label is found in lables array
                      const shouldDisplay = labels.length === 0 || labels.includes(data.label); 
                      if (shouldDisplay) {
                        const count = filteredResults && filteredResults.length > 0
                          ? filteredResults.filter((result) => {
                              return (
                                result.Fields.formattedPageTags.Value.indexOf(`"tagId":"${filter.tagPath}"`) >= 0
                                || result.Fields.formattedPageTags.Value.indexOf(`'tagId':'${filter.tagPath}'`) >= 0
                              );
                            }).length
                          : 0;

                        return (
                          <Filter 
                            filter={filter} 
                            count={count} 
                            updateFilters={updateFilters}
                          />
                        );
                      } else {
                        return null;
                      }
                    } else {
                      return null;
                    }
                  });
                })
              }
            </li>
          </ul>
        </div>
      </div>
    );
  } else {
    return null;
  }
};

export default FilterDrawerCategoryAccordion;
